<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-01-02 11:10:18
 * @FilePath: /smartEarthDemo/src/demo/video/vide.vue
 * @Description: 
-->
<template>
<div id='container'>
  <video id="trailer" autoplay loop crossorigin controls >
<!--    <source src="../../../public/data/video/video.mp4" type="video/mp4">-->
    <source src="/demo/static/earthx_assets/assets/video.mp4" type="video/mp4">
  </video>
</div>
</template>
<script>
import util from '../../components/util'
export default {
    data () {
        return {
         viewer:null
        }
    },
    mounted () {
        this.init();
    },
    methods:{
       init () {
        this.viewer=util.getViewer('container',{
            shouldAnimate : true,
            showRenderLoopErrors : false,
            timeline: false, // 时间滚动条控件
            navigationHelpButton: false, // 默认的相机控制提示控件
            animation: false, // 控制场景动画的播放速度控件
        });
        var videoElement = document.getElementById('trailer');

        var sphere = this.viewer.entities.add({
            position : Cesium.Cartesian3.fromDegrees(-79, 39, 10000),
            ellipsoid : {
                radii : new Cesium.Cartesian3(1000, 1000, 1000),
                material : videoElement
            }
        });
        let heading = Cesium.Math.toRadians(50);
        let pitch =  Cesium.Math.toRadians(-30);
        this.viewer.zoomTo(sphere,new Cesium.HeadingPitchRange(heading, pitch,6000))
       }
    }
}
</script>
<style>
#container {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
#trailer{
    display: none;
    position: absolute;
    z-index: 20;
    width: 320px;
    height: 180px;
    bottom: 75px;
    right: 30px;
}
</style>
